
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/approval-reminder.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-approval-reminder-demo-approval-reminder"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/approval-reminder.md?type=demo')
};